module.exports = __webpack_public_path__ + "img/7f55790.png";